<template>
	<div class="catalog-page">
		<!-- Шапка с поиском -->
		<div class="search-section">
			<div class="container">
				<h1>Каталог приложений для Аврора ОС</h1>
				<div class="catalog input-container">
					<input
									type="text"
									class="form-control"
									v-model="search"
									placeholder="Поиск..."
									@input="getResults()"
					/>
					<div
									class="clear-icon"
									v-if="search"
									@click="search='';getResults()"
									title="Очистить"
					></div>
				</div>
			</div>
		</div>

		<!-- Блок с клиентами -->
		<div class="download-clients">
			<div class="container">
				<h2>Скачать клиент для Аврора</h2>
				<div class="client-buttons">
					<a :href="app4.rpm32" class="client-btn">
						<i class="fas fa-download"></i> Аврора ОС 4 32 бита
					</a>
					<a :href="app5.rpm32" class="client-btn">
						<i class="fas fa-download"></i> Аврора ОС 5 32 бита
					</a>
					<a :href="app5.rpm64" class="client-btn">
						<i class="fas fa-download"></i> Аврора ОС 5 64 бита
					</a>
				</div>
			</div>
		</div>

		<!-- Поиск -->
		<div class="latest-apps" v-show="searchApp.length>0">
			<div class="container">
				<h2>По вашему запросу найдено</h2>
				<div class="apps-grid">
					<div
									class="app-card clickable-item"
									v-for="app in searchApp"
									:key="app.id"
					>
						<a :href="'/appdetail/' + app.latest_app.application_id  +'/' +app.latest_app.id  +'/' + app.latest_app.system">

						<div class="app-icon">
								<img :src="app.latest_app.icon" alt="Иконка приложения">
							</div>
						<div class="app-info">
							<h3>{{ app.name }}</h3>
							<div class="app-rating">
								<i class="fas fa-star" v-for="n in 5" :key="n"
									 :class="{ 'filled': n <= app.stars }"></i>
							</div>
							<div class="app-system">Доступно для Аврора {{ app.systems }}</div>
							<p class="app-category">{{ app.categorys }}</p>
						</div>
						</a>
					</div>
				</div>
			</div>
		</div>


		<!-- Последние добавленные -->
		<div class="latest-apps" v-show="searchApp.length==0">
			<div class="container">
				<h2>Последние добавленные</h2>
				<div class="apps-grid">
					<div
									class="app-card clickable-item"
									v-for="app in latestApps"
									:key="app.id"
					>
						<a :href="'/appdetail/' + app.application_id +'/' +app.id  +'/'+ app.system">

						<div class="app-icon">
								<img :src="app.icon" alt="Иконка приложения">
							</div>
						<div class="app-info">
							<h3>{{ app.name }}</h3>
							<div class="app-rating">
								<i class="fas fa-star" v-for="n in 5" :key="n"
									 :class="{ 'filled': n <= app.stars }"></i>
							</div>
							<div class="app-system">Доступно для Аврора {{ app.systems }}</div>
							<p class="app-category">{{ app.categorys }}</p>
						</div>
						</a>
					</div>
				</div>
			</div>
		</div>

		<!-- Популярные приложения -->

		<div class="popular-apps" v-show="searchApp.length==0">
			<div class="container">
				<h2>Популярные приложения</h2>
				<div class="apps-grid">
					<div
									class="app-card"
									v-for="app in popularApps"
									:key="app.id"
					>
						<a :href="'/appdetail/' + app.application_id +'/' +app.id  +'/' + app.system">

						<div class="app-icon">
							<img :src="app.icon" alt="Иконка приложения">
						</div>
						<div class="app-info">
							<h3>{{ app.name }}</h3>
							<div class="app-stats">
								<span><i class="fas fa-download"></i> {{ app.download_count }}</span>
								<span><i class="fas fa-star"></i> {{ app.stars }}</span>
							</div>
							<div class="app-system">Доступно для Аврора {{ app.systems }}</div>

							<p class="app-description "><span v-html=" truncateDescription(app.description)"></span></p>
						</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CatalogPage',
	data() {
		return {
			search: '',
			current_page: 1,
			searchApp: [],
			app4 : [],
			app5 : [],
			popularApps: [],
			id          : 0,
			pagination  : 20,
			sortable    : '',
			total       : 0,
			urls       : {
				index: "/api/site/index",
				app      : "/api/site/app?page=",
			},
			token       : document.head.querySelector('meta[name="csrf-token"]'),
		}
	},
	methods: {
		async getResults(page, sort) {
			if (page === undefined) {
				page = this.current_page;
			} else {
				this.current_page = page;
			}
			if (this.search==''){
				this.searchApp=[];
				return;
			}
			this.system = 1;
			console.log(1111);
			axios.get(this.urls.app + page, {
				params : {
					id        : this.id,
					sortable  : this.sortable,
					search    : this.search,
					system    : this.system,
					//user_id   : this.user_id,
					pagination: this.pagination
				},
				headers: {
					"X-CSRF-TOKEN": this.token.content,
				}
			})
							.then(({data}) => (
											this.searchApp = data.data
							));
		},
		async getData() {
			axios.get(this.urls.index)
							.then(({data}) => (
											this.latestApps = data.data.appNew,
															this.popularApps = data.data.appTop,
															this.app4 = data.data.app4,
															this.app5 = data.data.app5
							))
							.catch((errors) => {
								this.toastError(errors.response.data.errors);
							});
		}, goToAppDetail(appId, appVersionId) {
			this.$router.push({
				name: 'details',
				params: {
					id: appId,
					app_ver_id: appVersionId,
					system: 1
				}
			});
		},

		truncateDescription(desc) {
			return desc.length > 60 ? desc.substring(0, 60) + '...' : desc;
		}
	},
	mounted() {
		this.getData();
	}
}
</script>

<style scoped>
.catalog-page {
	font-family: 'Arial', sans-serif;
	color: #333;
}

.container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 0 15px;
}

/* Стили для поиска */
.search-section {
	background-color: #f5f5f5;
	padding: 40px 0;
	text-align: center;
}

.search-section h1 {
	margin-bottom: 20px;
	color: #2c3e50;
}

.search-box {
	display: flex;
	max-width: 600px;
	margin: 0 auto;
}

.search-box input {
	flex: 1;
	padding: 12px 15px;
	border: 1px solid #ddd;
	border-radius: 4px 0 0 4px;
	font-size: 16px;
}

.search-btn {
	padding: 0 20px;
	background-color: #3498db;
	color: white;
	border: none;
	border-radius: 0 4px 4px 0;
	cursor: pointer;
	font-size: 16px;
}

.search-btn:hover {
	background-color: #2980b9;
}

/* Стили для блока с клиентами */
.download-clients {
	padding: 30px 0;
	background-color: #fff;
	border-bottom: 1px solid #eee;
}

.download-clients h2 {
	text-align: center;
	margin-bottom: 20px;
	color: #2c3e50;
}

.client-buttons {
	display: flex;
	justify-content: center;
	gap: 20px;
	margin-top: 20px;
}

.client-btn {
	padding: 12px 25px;
	background-color: #27ae60;
	color: white;
	text-decoration: none;
	border-radius: 4px;
	font-weight: bold;
	transition: background-color 0.3s;
}

.client-btn:hover {
	background-color: #219653;
}

.client-btn i {
	margin-right: 8px;
}

/* Стили для приложений */
.latest-apps, .popular-apps {
	padding: 40px 0;
}

.latest-apps {
	background-color: #f9f9f9;
}

.popular-apps {
	background-color: #fff;
}

h2 {
	text-align: center;
	margin-bottom: 30px;
	color: #2c3e50;
}

.apps-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 25px;
}

.app-card {
	background: white;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s, box-shadow 0.3s;
	cursor: pointer;
}

.app-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.app-icon {
	height: 120px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f5f5;
}

.app-icon img {
	max-width: 80px;
	max-height: 80px;
	border-radius: 16px;
}

.app-info {
	padding: 15px;
}

.app-info h3 {
	margin: 0 0 10px 0;
	font-size: 16px;
	color: #2c3e50;
}

.app-rating {
	color: #f1c40f;
	margin-bottom: 8px;
}

.app-rating .filled {
	color: #f39c12;
}

.app-system {
	color: #71a9b7;
	margin-bottom: 8px;
	font-size: 14px;
}



.app-category {
	color: #7f8c8d;
	font-size: 14px;
	margin: 0;
}

.app-stats {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	font-size: 14px;
	color: #7f8c8d;
}

.app-description {
	font-size: 14px;
	color: #555;
	margin: 0;
	line-height: 1.4;
}

/* Адаптивность */
@media (max-width: 768px) {
	.apps-grid {
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	}

	.client-buttons {
		flex-direction: column;
		align-items: center;
	}

	.client-btn {
		width: 100%;
		max-width: 250px;
		text-align: center;
	}
}

@media (max-width: 480px) {
	.apps-grid {
		grid-template-columns: 1fr;
	}

	.search-box {
		flex-direction: column;
	}

	.search-box input {
		border-radius: 4px;
		margin-bottom: 10px;
	}

	.search-btn {
		border-radius: 4px;
	}
}
</style>